import { render } from "./Contact.vue?vue&type=template&id=57a10b16&scoped=true&ts=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=57a10b16&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.1_vue@3.3.11_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a10b16"]])

export default __exports__